import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

createRoot(document.getElementById('leahles-children-campaign')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
